/**
 * Whitelabel das mensagens traduzidas — fork SeguroCor.
 *
 * O CE já troca a marca no que vem de configuração (logo, título, "Powered by"), mas o nome
 * "Chatwoot" continua cravado dentro das STRINGS de tradução — são dezenas só no inglês, e o
 * mesmo se repete em cada um dos ~35 idiomas.
 *
 * Editar os arquivos de locale seria trocar centenas de linhas que o upstream mexe a cada
 * release: todo merge viraria conflito. Em vez disso, a substituição acontece uma vez no boot,
 * sobre o objeto de mensagens já montado. Nenhum arquivo de tradução é tocado, e ao subir de
 * versão as strings novas do upstream já entram com a marca certa.
 *
 * Mesma semântica do `replaceInstallationName` (shared/composables/useBranding), aplicada de
 * forma global em vez de componente a componente.
 */

/** Marca padrão que aparece nas traduções do upstream. */
const UPSTREAM_BRAND = /Chatwoot/g;

/**
 * Substitui a marca do upstream pelo nome da instalação em toda a árvore de mensagens.
 * Sem `INSTALLATION_NAME` configurado (ou igual ao padrão), devolve as mensagens intactas.
 *
 * @param {object} messages árvore de mensagens do vue-i18n (locale → chaves aninhadas)
 * @param {string} installationName nome da instalação (window.globalConfig.INSTALLATION_NAME)
 * @returns {object} nova árvore com a marca substituída
 */
export function applyBrandToMessages(messages, installationName) {
  if (!installationName || installationName === 'Chatwoot') return messages;

  const replaceDeep = value => {
    if (typeof value === 'string')
      return value.replace(UPSTREAM_BRAND, installationName);
    if (Array.isArray(value)) return value.map(replaceDeep);
    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, item]) => [key, replaceDeep(item)])
      );
    }
    return value;
  };

  return replaceDeep(messages);
}

/** Açúcar para os entrypoints: lê o nome da instalação do globalConfig injetado pelo Rails. */
export function brandedMessages(messages) {
  return applyBrandToMessages(messages, window.globalConfig?.INSTALLATION_NAME);
}
